module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "book"
  }, [_vm._m(0), _vm._v(" "), _vm._m(1), _vm._v(" "), _c('div', {
    staticClass: "authorInfo"
  }, [_c('h2', {
    staticClass: "authorName heading font1"
  }, [_vm._v("\n      Sylvia Browne\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "authorDescription body article"
  }, [_c('P', [_vm._v("Sylvia Browne (October 19, 1936 – November 20, 2013) was a #1 "), _c('I', [_vm._v("New York Times")]), _vm._v(" bestselling author and world-famous psychic who appeared regularly on the "), _c('I', [_vm._v("Montel Williams Show")]), _vm._v(" and on "), _c('I', [_vm._v("Larry King Live")]), _vm._v(", as well as making countless other media and public appearances. She also founded the Society of Novus Spiritus church, which celebrated its 25th anniversary in 2011.")], 1)], 1)]), _vm._v(" "), _vm._m(2)])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "coverInfo"
  }, [_c('img', {
    staticClass: "coverImage",
    attrs: {
      "src": "//textcafe.co/books/uV6hCg/tc-custom/9780061995477.jpg?1718079115739",
      "alt": "This image is the cover for the book Psychic"
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "bookInfo"
  }, [_c('h1', {
    staticClass: "bookTitle heading font1"
  }, [_vm._v("Psychic\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "bookDescription body article font2"
  }), _c('p', [_vm._v("“I have known Sylvia for twenty years, and I have the greatest respect for her. People seek her out for her much celebrated intuitive skills, however, I have sought her out for her friendship and kindness. I applaud her for the peace and solace that she has brought to so many.” — Montel Williams ")]), _c('p', [_vm._v("“An amazing woman, an amazing life, and a book I couldn’t put down. Sylvia is a true inspiration.” — Jeanne Cooper, star of "), _c('i', [_vm._v("The Young and the Restless")])]), _c('p', [_vm._v("Reaching deep beneath the surface of her life—then and now—renowned psychic and #1 "), _c('i', [_vm._v("New York Times")]), _vm._v(" bestselling author Sylvia Browne ("), _c('i', [_vm._v("The Other Side and Back")]), _vm._v(") candidly discusses details of her professional and personal experiences that she’s never publically revealed before.")]), _vm._v(" "), _c('p')])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "publisherInfo"
  }, [_c('h2', {
    staticClass: "publisherName heading font1"
  }, [_vm._v("\n    HarperCollins\n   ")])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-cb664236","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/home.vue
// module id = 51
// module chunks = 0